import { ROUTES } from "@lib/constants";
import { IRoute } from "@lib/types/Routes";
import SignIn from "@app/Auth/Signin";
import TwoFactor from "@app/Auth/TwoFactor";

// const ForgotPassword = React.lazy(
//   () => import("@app/Auth/ForgetPassword/ForgetPasswordJwtAuth"),
// );
// const ResetPasswordAwsCognito = React.lazy(
//   () => import("@app/Auth/ForgetPassword/ResetPasswordAwsCognito"),
// );
export const authRouteConfig: IRoute[] = [
  {
    path: ROUTES.AUTH.LOGIN,
    element: <SignIn />,
  },
  {
    path: ROUTES.AUTH.TWO_FACTOR,
    element: <TwoFactor />,
  },
  // {
  //   path: "/auth/forget-password",
  //   element: <ForgotPassword />,
  // },
  // {
  //   path: "/auth/reset-password",
  //   element: <ResetPasswordAwsCognito />,
  // },
];
